/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const get_sellerPackages_webSiteOrigin = createAsyncThunk(
    'home/get_sellerPackages_webSiteOrigin',
    //'sellerPackage/get_sellerPackages_webSiteOrigin',
    async(webSiteOrigin, { fulfillWithValue }) => {
        //console.log(webSiteOrigin)
        try {
            const {data} = await api.get(`/get-sellerPackages-webSiteOrigin/${encodeURIComponent(webSiteOrigin)}`)
            //console.log('get_sellerPackages_webSiteOrigin ', data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response.data)
            //return rejectWithValue(error.response.data)
        }
    }
);
//end method

export const get_one_sellerPackage = createAsyncThunk(
    'home/get_one_sellerPackage',
    async(query, { rejectWithValue, fulfillWithValue }) => {
        try {
            //KEEP THIS ON ONE LINE!!
            const {data} = await api.get(`/get-one-sellerPackage?webSiteOrigin=${query.webSiteOrigin}&&title=${query.title} `)
            //console.log('get_one_sellerPackage ', data)
            return fulfillWithValue(data)
        } catch (error) {
            //console.log(error)
           console.log(error.response.data)
            //return rejectWithValue(error.response.data)
        }
    }
);
//end method

export const sellerPackageReducer = createSlice({
    name: 'sellerPackage',
    initialState:{
        successMessage :  '', 
        errorMessage : '', 
        sellerPackage : {},
        sellerPackages : [], 
        totalSellerPackage: 0
    },
    reducers : {
        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers : (builder) => {
         builder
        .addCase(get_sellerPackages_webSiteOrigin.fulfilled, (state, { payload }) => {
            state.totalSellerPackage = payload.totalSellerPackage;
            state.sellerPackages = payload.sellerPackages;
            //console.log(state.sellerPackages) //works
            //console.log('get_sellerPackages_webSiteOrigin ', payload.sellerPackages, payload.totalSellerPackage)
            
        })
        .addCase(get_one_sellerPackage.fulfilled, (state, { payload }) => {
            //state.totalSellerPackage = payload.totalSellerPackage;
            state.sellerPackage = payload.sellerPackage;
            //console.log(state.sellerPackages) //works
            //console.log('get_sellerPackages_webSiteOrigin ', payload.sellerPackages, payload.totalSellerPackage)
        })
        .addCase(get_one_sellerPackage.rejected, (state, { payload }) => {
            state.errorMessage = payload.error;
        })
    }
})

export const {messageClear} = sellerPackageReducer.actions
export default sellerPackageReducer.reducer
